import http from '../common/http-auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllRoles = async (roleId?: number) => {
        // Explicitly handle null, undefined, 0, and NaN cases
        const url = (roleId != null && !isNaN(roleId) && roleId !== 0) ? `/role/getallroles?roleId=${roleId}` : '/role/getallroles';
        // Send the GET request
        const response = await http.get(url);
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllMenuPermissionsById = async (id: number) => {
    const response = http.get(`/menu/menu-permissions/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllUsersById = async (id: number) => {
    const response = http.get(`/role/user/list/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addRole = async (data: any) => {
    const response = http.post(`/role/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deleteRole = async(roleId: number, deletedBy: number) => {
    const response = http.delete(`/role/delete?roleId=${roleId}&deletedBy=${deletedBy}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const deactivateRole = async(roleId: number, isActive: boolean, modifiedBy: number) => {
    const response = http.post(`/role/user/roletoggleactivation?roleId=${roleId}&isActive=${isActive}&modifiedBy=${modifiedBy}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const updateRole = async (data: any) => {
    const response = http.put(`/role/update`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addUsersToRole = async (data: any) => {
    const response = http.post(`/role/user/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
export const addMenuPermissions = async (data: any) => {
    const response = http.post(`/menu/menu-permissions/add`, data)
    return response;
}